import { Field, Form, HousingAlert, Sender } from "@garantidos/components"

import { Link, Text } from "@mobi/ds"

import useCpf from "./hooks"

import "../../style.scss"

const CpfOneClick = () => {
  const {
    onSubmitCallback,
    fields,
    form,
    errorMessage,
    setErrorMessage,
    isLoading
  } = useCpf()
  const { cpf } = fields
  const { isValid } = form

  return (
    <div className="softleadSimulationOneClick">
      <div className="softleadSimulationOneClick__formWrapper">
        <HousingAlert
          message={errorMessage}
          setMessage={setErrorMessage}
          type="error"
        />
        <h1 className="softleadSimulationOneClick__title">
          pra começar, insira o seu CPF
        </h1>
        <Form onSubmit={onSubmitCallback} form={form}>
          <Field
            field={cpf}
            form={form}
            data-testid={cpf.name}
            disabled={isLoading}
          />{" "}
          <Text as="p" className="softleadSimulationOneClick__legalText space">
            Ao continuar seu pedido, você está ciente da Política de{" "}
            <Link
              href="https://www.itau.com.br/privacidade"
              target="_blank"
              rel="noreferrer"
              size="xs"
            >
              Privacidade Itaú
            </Link>{" "}
            e aceita as condições{" "}
            <Link
              href="https://www.itau.com.br/seguranca/sistema-informacao-credito"
              target="_blank"
              rel="noreferrer"
              size="xs"
            >
              do Sistema de Informações de Crédito (SCR)
            </Link>{" "}
          </Text>
          <Sender
            showPrev={false}
            data_testid="submit"
            isNextDisabled={!isValid}
            nextLabel="avançar"
            isLoading={isLoading}
          />
        </Form>
      </div>
    </div>
  )
}

export default CpfOneClick
